document.addEventListener('DOMContentLoaded', () => {
	const printListButton = document.querySelector('[data-trigger="open-printlist-popup"]');
	const printListButtonIcon = printListButton?.querySelector('.icon');
	let currentPrintList = localStorage.getItem('printList');
	let parsedList = null;

	try {
		parsedList = JSON.parse(currentPrintList);
	} catch {
		parsedList = [];
	}

	// Set the number of items in the print list
	if (parsedList && printListButtonIcon) {
		printListButtonIcon.dataset.numItems = parsedList.length;
	}

	// Code basic print list popup functionality like close and click-off
	const printListPopup = document.querySelector('[data-modal="printlist-popup"]');
	const printListPopupContent = printListPopup?.querySelector('ul.list');
	const closeBtn = printListPopup?.querySelector('[aria-label="close"]');
	const printButton = document.querySelector('[data-trigger="print-printlist"]');
	const clearButton = document.querySelector('[data-trigger="clear-printlist"]');
	closeBtn?.addEventListener('click', () => {
		printListPopup?.classList.remove('active')
	})
	window.addEventListener('click', e => {
		if (
			e.target.closest('[data-modal="printlist-popup"]') &&
			!e.target.closest('[data-modal="printlist-popup"] .card')
		) {
			printListPopup?.classList.remove('active')
		}
	})

	// Code to set the visual state of the faux-checkbox buttons when the page is loaded,
	// based on whether or not this service is in the print list.
	// This is scoped to the service and organization template pages so we don't conflict with the Preact search results page,
	// which handles styling separately.
	const templateAddButtons = document.querySelectorAll('body.service-template [data-trigger="add-to-printlist"], body.organization-template [data-trigger="add-to-printlist"]');
	templateAddButtons.forEach(button => {
		const serviceID = parseInt(button.dataset.serviceId);
		if (parsedList != null) {
			if (parsedList.find(item => item.id === serviceID)) {
				button.classList.add('checked');
			}
		}
	})

	const addButtonClickHandler = (e) => {
		button = e.target;
		currentPrintList = localStorage.getItem('printList');
		try {
			parsedList = JSON.parse(currentPrintList);
		} catch {
			parsedList = [];
		}
		const serviceID = parseInt(button.dataset.serviceId);
		const serviceTitle = button.dataset.serviceTitle;
		const serviceOrg = button.dataset.serviceOrg;
		const serviceUrl = button.dataset.serviceUrl;
		const serviceOrgUrl = button.dataset.serviceOrgUrl;
		if (parsedList == null) {
			localStorage.setItem('printList', JSON.stringify([{ "id": serviceID, "title": serviceTitle, "org": serviceOrg, "serviceUrl": serviceUrl, "orgUrl": serviceOrgUrl }]));
			button.classList.add('checked');
			printListButtonIcon.dataset.numItems = parseInt(printListButtonIcon.dataset.numItems) + 1;
		} else if (parsedList.find(item => item.id === serviceID)) {
			let removeIndex = parsedList.indexOf(parsedList.find(item => item.id === serviceID));
			if (removeIndex > -1) {
				parsedList.splice(removeIndex, 1);
				button.classList.remove('checked');
				printListButtonIcon.dataset.numItems = parseInt(printListButtonIcon.dataset.numItems) - 1;
				localStorage.setItem('printList', JSON.stringify(parsedList));
			}
		} else {
			parsedList.push({ "id": serviceID, "title": serviceTitle, "org": serviceOrg, "serviceUrl": serviceUrl, "orgUrl": serviceOrgUrl });
			button.classList.add('checked');
			printListButtonIcon.dataset.numItems = parseInt(printListButtonIcon.dataset.numItems) + 1;
			localStorage.setItem('printList', JSON.stringify(parsedList));
		}
		window.dispatchEvent(new Event('custom-storage-printlist'))
	}
	// Code for faux-checkbox buttons to add/remove items from the print list
	// This DOES also attach to faux checkboxes on the search results page
	let addButtons = document.querySelectorAll('[data-trigger="add-to-printlist"]');
	if (addButtons) {
		addButtons.forEach(button => {
			button.addEventListener('click', addButtonClickHandler)
		})
	}
	// When the search results page DOM changes, we need to update the addButtons nodelist
	const targetNode = document.getElementById("results");
	const config = { attributes: false, childList: true, subtree: false };
	const callback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === "childList") {
				addButtons = document.querySelectorAll('[data-trigger="add-to-printlist"]');
				addButtons.forEach(button => {
					button.addEventListener('click', addButtonClickHandler)
				})
			}
		}
	};
	const observer = new MutationObserver(callback);
	if (targetNode) {
		observer.observe(targetNode, config);
	}

	// Code for the print list button, to open the popup dialog with the list of services
	if (printListButton) {
		printListButton.addEventListener('click', () => {
			currentPrintList = localStorage.getItem('printList');
			try {
				parsedList = JSON.parse(currentPrintList);
			} catch {
				parsedList = [];
			}
			let listItems = [];

			parsedList?.forEach(item => {
				const listItem = document.createElement('li');
				const itemTitle = document.createElement('a');
				const itemOrg = document.createElement('span');
				const itemOrgLink = document.createElement('a');
				const deleteItem = document.createElement('button');

				itemTitle.classList.add('title', 'h6');
				itemTitle.setAttribute('href', item.serviceUrl);
				itemOrg.classList.add('org', 'p', 'lg');
				itemOrgLink.setAttribute('href', item.orgUrl);
				deleteItem.classList.add('delete-item');
				deleteItem.setAttribute('data-trigger', 'remove-from-printlist');
				deleteItem.setAttribute('data-service-id', item.id);

				itemTitle.innerText = item.title;
				itemOrg.innerText = 'by ';
				itemOrgLink.innerText = item.org;

				itemOrg.appendChild(itemOrgLink);
				listItem.appendChild(itemTitle);
				listItem.appendChild(itemOrg);
				listItem.appendChild(deleteItem);
				listItems.push(listItem);
			})

			printListPopupContent.replaceChildren(...listItems);
			printListPopup.classList.add('active');

			// Make print and clear buttons active if applicable
			if (parsedList && parsedList.length > 0) {
				printButton.removeAttribute('disabled');
				clearButton.removeAttribute('disabled');
			}

			// Code for removing items from the print list and clearing the print list
			const removeButtons = document.querySelectorAll('[data-trigger="remove-from-printlist"]');
			removeButtons.forEach((button) => {
				button.addEventListener('click', () => {
					const removeServiceID = parseInt(button.dataset.serviceId);
					currentPrintList = localStorage.getItem('printList');
					try {
						parsedList = JSON.parse(currentPrintList);
					} catch {
						parsedList = [];
					}
					let removeIndex = parsedList.indexOf(parsedList.find(item => item.id === removeServiceID));
					if (removeIndex > -1) {
						parsedList.splice(removeIndex, 1);
						localStorage.setItem('printList', JSON.stringify(parsedList));
						window.dispatchEvent(new Event('custom-storage-printlist'))
						printListButtonIcon.dataset.numItems = parseInt(printListButtonIcon.dataset.numItems) - 1;
						button.closest('li').remove();
						templateAddButtons.forEach(addButton => {
							const serviceID = parseInt(addButton.dataset.serviceId);
							if (serviceID === removeServiceID) {
								addButton.classList.remove('checked');
							}
						});
						if (parsedList.length <= 0) {
							printButton.setAttribute('disabled', '');
							clearButton.setAttribute('disabled', '');
						}
					}
				})
			})
			clearButton?.addEventListener('click', () => {
				localStorage.removeItem('printList');
				window.dispatchEvent(new Event('custom-storage-printlist'))
				printListButtonIcon.dataset.numItems = 0;
				printListPopupContent.replaceChildren();
				printButton.setAttribute('disabled', '');
				clearButton.setAttribute('disabled', '');
				templateAddButtons.forEach(addButton => {
					addButton.classList.remove('checked');
				});
			})

			// Code for the actual print button
			printButton.addEventListener('click', () => {
				const printWindow = document.getElementById('printWindow');
				if (printWindow) {
					printButton.innerText = 'Getting data...';
					printButton.classList.remove('icon-after');
					printWindow.src = window.location.origin + '/print-results?serviceIds=' + parsedList.map(item => item.id).join(',');
					printWindow.addEventListener('load', () => {
						printButton.innerText = 'Print List';
						printButton.classList.add('icon-after');
						printWindow.focus();
						printWindow.contentWindow.print();
					})
				}
			})
		})
	}
})
